(() => {
  const motion = window.WTCTheme.motion;
  window.WTCTheme.register('#seasonal-dialog', (dialog) => {
    if (typeof dialog.showModal !== 'function') return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const storageKey = `wtc-seasonal-seen-${dialog.dataset.seasonalKey}`;
    const day = 86400000;
    let previousOverflow = '';
    let animation;
    let closing = false;
    let seen = false;
    let automaticReady = false;
    const open = () => {
      if (dialog.open || document.querySelector('dialog[open]')) return;
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      seen = true;
      animation = motion.animate(dialog, [
        { opacity: 0, transform: 'translateY(12px) scale(.98)' },
        { opacity: 1, transform: 'translateY(0) scale(1)' },
      ]);
      try { localStorage.setItem(storageKey, String(Date.now())); } catch { /* Storage is optional. */ }
    };
    const close = async () => {
      if (!dialog.open || closing) return;
      closing = true;
      dialog.dataset.closing = '';
      animation?.cancel();
      animation = motion.animate(dialog, [
        { opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(8px)' },
      ]);
      await motion.finished(animation);
      dialog.close();
    };
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-seasonal-open]')) open();
      if (event.target.closest('[data-seasonal-close]')) close();
    }, options);
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
    }, options);
    dialog.addEventListener('keydown', (event) => motion.trapFocus(event, dialog), options);
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); }, options);
    dialog.addEventListener('close', () => {
      closing = false;
      delete dialog.dataset.closing;
      document.documentElement.style.overflow = previousOverflow;
    }, options);
    try {
      const lastSeen = Number(localStorage.getItem(storageKey));
      seen = lastSeen > 0 && Date.now() - lastSeen < day;
    } catch { seen = true; }
    const showWhenVisible = () => {
      if (automaticReady && !seen && document.visibilityState === 'visible') open();
    };
    document.addEventListener('visibilitychange', showWhenVisible, options);
    document.addEventListener('wtc:overlay-closed', showWhenVisible, options);
    const timer = dialog.dataset.seasonalAuto === 'true' && !seen ? setTimeout(() => {
      automaticReady = true;
      showWhenVisible();
    }, (Number(dialog.dataset.seasonalDelay) || 6) * 1000) : null;
    return () => {
      clearTimeout(timer);
      controller.abort();
      animation?.cancel();
      if (dialog.open) {
        dialog.close();
        document.documentElement.style.overflow = previousOverflow;
      }
    };
  });
})();
